import {
  Box,
  Button,
  Checkbox,
  Container,
  CssBaseline,
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  InputLabel,
  List,
  MenuItem,
  Select,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import LabelImportantIcon from "@mui/icons-material/LabelImportant";
import { Message } from "../../Interface/Message";
import { AppSettings } from "../../AppSettings";
import { User } from "../../Interface/IUser";
import Loader from "../Loader";
import AppHelper from "../../Helper/AppHelper";
import AlertBox from "../CommonComponent/AlertBox";
import { mdmAccesses, Role } from "../../Interface/Role";
import { PersonAdd } from "@mui/icons-material";
import ListItem from "@mui/material/ListItem";
import { ListSubheader, Switch } from "@mui/material";
import ListItemText from "@mui/material/ListItemText";
import SettingsIcon from '@mui/icons-material/Settings';
import AddIcon from '@mui/icons-material/Add';

function CreateEditUser(): JSX.Element {
  const [isUpdateForm, setUpdateForm] = React.useState(false);
  const [pageName, setPageName] = React.useState("");
  const [showPasswordSection, setShowPasswordSection] = React.useState(false);
  const navigate = useNavigate();
  const [openLoader, setOpenloader] = React.useState(false);
  const [isChecked, setIsChecked] = React.useState(true);
  const [confirmPassword, setConfirmPassword] = React.useState("");
  const [roleList, setRoleLists] = React.useState<Role[]>([]);
  const [MDMroleList, setMDMRoleLists] = React.useState<mdmAccesses[]>([]);
  const [mdmchecked, setChecked] = React.useState([""]);
  const [isShownMDMBTN, shownMDMBTN] =  React.useState(true);  
  const userCollection: string[] = ["Admin", "DSV Employee","Super Admin"]
  const [isShowSuperAdmin, ShowSuperAdmin] =  React.useState(true); 


//Search 
const [searchText, setSearchText] =React.useState('');
const [selectedOptions, setSelectedOptions] = React.useState<mdmAccesses[]>([]);

const handleSearchChange = (  event:
  | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  | (Event & { target: { value: string; id: string } })) => {
    
  setSearchText(event.target.value);
};

// const handleToggleOption = (option: mdmAccesses) => () => {
//   if (selectedOptions.includes(option)) {
//     setSelectedOptions(selectedOptions.filter(item => item !== option));
//   } else {
//     setSelectedOptions([...selectedOptions, option]);
//   }
// };

const filteredOptions = MDMroleList.filter(option =>
  (option?.description || '' ).toLowerCase().includes(searchText.toLowerCase())
);


//End search 


  const handleRoleToggle = (mdmAccesses: mdmAccesses) => () => {
    let id = mdmAccesses.id || "";
    let value = `${id}`;
    const currentIndex = mdmchecked.indexOf(value);
    const newChecked = [...mdmchecked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    setChecked(newChecked);

  };


  const [isShownMDMRoles, setShownMDMRoles] = React.useState(false);

  function getRoleID(mdmAccesses: mdmAccesses) {
    let id = mdmAccesses.id || "";
    let value = `${id}`;    
    return value;
  }

  const [userInfo, setUsersInfo] = React.useState<User>({
    id: 0,
    username: "",
    firstName: "",
    lastName: "",
    phoneNumber: "",
    password: "",
    email: "",
    createdBy: "",
    isActive: true,
    isMDMActive:true,
    roleID: "",
    userType: "",
    passwordResetRequired: false,
    passwordResetAlertMessage: "",
    token: "",
    mdmAccesses:[{ id: 0, name: "", description: "", roleCode: "", isActive: true, link: "" }],
  });



  const [formValidation, setformValidation] = React.useState({
    email: false,
    firstName: false,
    password: false,
    confirmPassword: false,
    roleID: false,
    phoneNumber: false,
    userType: false,
  });
  const [alertBoxmsg, setAlertBoxmsg] = React.useState<Message>({
    Type: "",
    Text: "",
  });

  const useEffectCount = React.useRef(true);
  React.useEffect(() => {
    if (useEffectCount.current) {
      let superAdmin = false;
      if(AppHelper.getUser().userType ==="Admin")
      {
        AppHelper.isAdminUser();
        ShowSuperAdmin(false);
      }
      else
      if(AppHelper.getUser().userType ==="Super Admin")
      {
        AppHelper.isSuperAdminUser();
          ShowSuperAdmin(true);
          superAdmin = true;
      }
      useEffectCount.current = false;
      setOpenloader(true);
      let msg: Message = { Text: "", Type: "" };
      let apiUrl = "";
      let query = AppHelper.getQueryValue().get("id");
    
      bindRoles(query || "");
      bindMDMRoles(query || "", superAdmin); 
      if (query === null) {
        return;
      }

      if (query != undefined || query != "" || query != null) {
        setPageName("Edit User");
        setOpenloader(true);
        apiUrl = AppSettings.API_URL + "User/GetUserDetails?id=" + query;
        fetch(apiUrl, AppHelper.requestOptions("POST"))
          .then((response) => {
            console.log(response);
            if (!response.ok) {
              if (response.status == 401) navigate("/SessionExpired");
              else
                throw new Error(
                  `API Error, This is an HTTP error: The status is ${response.status}`
                );
            }
            return response.json();
          })
          .then((data) => {
            if (data != undefined) {
              let user: User = data || " ";
              setUpdateForm(true); 
              setUsersInfo(user);           
              setIsChecked(user.isActive || false);   
              if(user.isMDMActive == true)
              {
                  bindEditedMDMUserRoles(user);
              }
              if(!userCollection.includes(user?.userType ||'')){
                shownMDMBTN(false);
              }
            }
          })
          .catch((err) => {
            if (err.message === "Failed to fetch") {
              navigate("/SessionExpired");
            } else {
              //API Error.
              msg = { Text: err.message, Type: "Error" };
              setAlertBoxmsg(msg);
            }
          })
          .finally(() => {
            setOpenloader(false);
          });
      }
    }
  }, []);

  function handleCloase() {
    setShownMDMRoles(false);
  }

function bindEditedMDMUserRoles(user: User) {
  const newChecked = [""];
  if (user.username != "" && user.mdmAccesses != null) {
    const newChecked=[""];
   
    user.mdmAccesses.map((mdmAccess) => { 
      let id = mdmAccess.id|| "";
      let value = `${id}`;
      if (!newChecked.includes(value)) {
        newChecked.push(value);
      }
      setChecked(newChecked);
    });
  }
}

function bindEditedMDMRoles(user: User) {
  const newChecked = [""]; 
 debugger;
  if (user.id != null) {
    user.mdmAccesses.map((mdmAccess) => {
      let id = mdmAccess.id|| "";
      let value = `${id}`;
      if (!newChecked.includes(value)) {
        newChecked.push(value);
      }
    });
    
    let mdmAccesses: mdmAccesses[] = user.mdmAccesses || " ";
    let activeRoles = mdmAccesses.filter((x) => x.isActive === true);
    setMDMRoleLists(activeRoles); 
    setChecked(newChecked); 
  }
}

function bindMDMRoles(query: string, superAdmin: boolean) {
  setOpenloader(true);
  let apiUrl = AppSettings.API_URL + "Role/GetAllMDMAccesses?superAdmin=" + (superAdmin ? "true" : "false");
  fetch(apiUrl, AppHelper.requestOptions("POST"))
    .then((response) => {
      console.log(response);
      if (!response.ok) {
        if (response.status == 401) navigate("/SessionExpired");
        else
          throw new Error(
            `API Error, This is an HTTP error: The status is ${response.status}`
          );
      }
      return response.json();
    })
    .then((data) => {
      if (data != undefined) {
       
        if (!isUpdateForm) { 
          let mdmAccesses: mdmAccesses[] = data || " ";
          let activeRoles = mdmAccesses.filter((x) => x.isActive === true);
          setMDMRoleLists(activeRoles);
        } else {
          let mdmAccesses: mdmAccesses[] = data || " ";
          let activeRoles = mdmAccesses.filter((x) => x.isActive === true); 
          setMDMRoleLists(data); 
        const newChecked=[""];
        mdmAccesses.map((mdmAccess) => {
          let id = mdmAccess.id|| "";
          let value = `${id}`;
          if (!newChecked.includes(value)) {
            newChecked.push(value);
          }
        });
      
      setMDMRoleLists(activeRoles);
      setChecked(newChecked); 
        }
      }
    })
    .catch((err) => {
      if (err.message === "Failed to fetch") {
        navigate("/SessionExpired");
      } else {
        console.log("API Error: " + apiUrl + " " + err);
      }
    })
    .finally(() => {
      if (query === "") setOpenloader(false);
    });
}

  function bindRoles(query: string) {
    setOpenloader(true);
    let apiUrl = AppSettings.API_URL + "Role/GetAllRoles";
    fetch(apiUrl, AppHelper.requestOptions("POST"))
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          if (response.status == 401) navigate("/SessionExpired");
          else
            throw new Error(
              `API Error, This is an HTTP error: The status is ${response.status}`
            );
        }
        return response.json();
      })
      .then((data) => {
        if (data != undefined) {
          if (!isUpdateForm) {
            let roles: Role[] = data || " ";
            let activeRoles = roles.filter((x) => x.isActive === true);
            setRoleLists(activeRoles);
          } else {
            setRoleLists(data);
          }
        }
      })
      .catch((err) => {
        if (err.message === "Failed to fetch") {
          navigate("/SessionExpired");
        } else {
          console.log("API Error: " + apiUrl + " " + err);
        }
      })
      .finally(() => {
        if (query === "") setOpenloader(false);
      });
  }

  const handleCheckboxChange = (event: {
    target: { checked: boolean | ((prevState: boolean) => boolean) };
  }) => {
    setIsChecked(event.target.checked);
  };
 
  function containsValue(value: string, collection: string[]): boolean {
    return collection.includes(value);
}
  
  const handleSelectChange = (event: SelectChangeEvent, id: string) => {
    var value = "";
    if (id === "roleID") {
      if (event.target.value != null && event.target.value != undefined) {
        value = event.target.value.toString();
        setUsersInfo({ ...userInfo, ["roleID"]: value });
      }
    }
    if (id === "userType") {
      if (event.target.value != null && event.target.value != undefined) {
        value = event.target.value.toString();
        
        setUsersInfo({ ...userInfo, ["userType"]: value });        
    
        if(userCollection.includes(value))
        {          
          shownMDMBTN(true);
          }else{
          shownMDMBTN(false);
        }    
      }
    }
    isValidUser(id, value);
  };

  const handleInputChange = (
    e:
      | React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      | (Event & { target: { value: string; id: string } })
  ) => {
    const { id, value } = e.target;
    if (id == "confirmPassword") {
      setConfirmPassword(value);
    }
    setUsersInfo({ ...userInfo, [id]: value });
    isValidUser(id, value);
  };

  const ManageMDM = ()=>{
    setShownMDMRoles(true); 
  }

  function IsValidRoleID(itemID: string) {
    if (!AppHelper.isNullorEmptyNumber(itemID)) {
      let roles: Role[] = roleList;
      var selectedId: number = +itemID;
      let validID = roleList.find((x) => x.id === selectedId);
      if (validID === undefined) {
        return false;
      }
      return true;
    } else {
      return false;
    }
  }

  function isValidUser(itemID: string, value: string) {
    let validate = {
      firstName: AppHelper.isNullorEmpty(userInfo.firstName),
      email: AppHelper.isNullorEmpty(userInfo.email),
      password: AppHelper.isNullorEmpty(userInfo.password),
      confirmPassword: AppHelper.isNullorEmpty(confirmPassword),
      roleID: !IsValidRoleID(userInfo.roleID || ""),
      phoneNumber: false,
      userType: AppHelper.isNullorEmpty(userInfo.userType),
    };

    if (!AppHelper.validateEmail(userInfo.email || "")) {
      validate.email = true;
    }

    if (itemID == "phoneNumber") {
      if (!AppHelper.validatePhone(value || "")) {
        validate.phoneNumber = true;
      }
    } else {
      if (!AppHelper.validatePhone(userInfo.phoneNumber || "")) {
        validate.phoneNumber = true;
      }
    }

    if (itemID == "roleID") {
      if (value.trim() === "") {
        validate.roleID = true;
      } else {
        validate.roleID = !IsValidRoleID(value);
      }
    }

    if (!AppHelper.validatePassword(userInfo.password || "")) {
      validate.password = true;
    }

    if (!showPasswordSection) {
      validate.password = false;
      validate.confirmPassword = false;
    } else {
      if (itemID == "confirmPassword") {
        if (userInfo.password != value) {
          validate.confirmPassword = true;
        }
      } else {
        if (userInfo.password != confirmPassword) {
          validate.confirmPassword = true;
        }
      }
    }

    setformValidation(validate);

    if (
      validate.email ||
      validate.password ||
      validate.firstName ||
      validate.roleID ||
      validate.confirmPassword ||
      validate.phoneNumber
    ) {
      return false;
    }
    return true;
  } 
  
  const handleSubmit = () => {
   
    setOpenloader(true);

    if (!isValidUser("", "")) {
      setOpenloader(false);
      return false;
    }

    let msg: Message = { Text: "", Type: "" };

    let apiUrl = "";
    if (!isUpdateForm) {
     
      apiUrl = AppSettings.API_URL + "User/AddUser";
    } else {
      apiUrl = AppSettings.API_URL + "User/UpdateUser";
    }

    var mdmAccesses: mdmAccesses[] = [];
    var arrayLength = mdmchecked.length;
    for (var i = 0; i < arrayLength; i++) {
      var y: number = +mdmchecked[i]; 
      if (y != 0) {
        mdmAccesses.push({
          id: y,
          name: "string",
          description: "string",
          roleCode: "string",
          isActive: true,
          link: "string",         
        }      
        );
      }     
    }
     
    var isMDMActive = false;
    if(userCollection.includes(userInfo.userType || ''))
    {
      if(mdmAccesses.length !=0){
        isMDMActive =true;
      }else{isMDMActive=false;}
    }else{
      mdmAccesses = [];
    } 


    

   
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + AppHelper.getUser().token,
      },
      body: JSON.stringify({
        id: userInfo.id,
        username: userInfo.email,
        email: userInfo.email,
        password: userInfo.password || "",
        firstName: userInfo.firstName,
        lastName: userInfo.lastName,
        phoneNumber: userInfo.phoneNumber,
        roleID: userInfo.roleID,
        userType: userInfo.userType,
        company: "",
        isActive: isChecked,
        isMDMActive:isMDMActive,
        createdBy: AppHelper.getUser().id.toString(),
        mdmAccesses: mdmAccesses,
      }),
    };

    fetch(apiUrl, requestOptions)
      .then((response) => {
        console.log(response);
        if (!response.ok) {
          if (response.status == 401) navigate("/SessionExpired");
          else
            throw new Error(
              `API Error, This is an HTTP error: The status is ${response.status}`
            );
        }
        return response.json();
      })
      .then(
        (data) => {
          if (data) {
            if (data.successes.length > 0) {
              if (isUpdateForm) {
                navigate("/UserList?msg=Update_Successful");
              } else {
                navigate(`/UserList?msg=Create_Successful&userType=${userInfo.userType}`);
              }
            } else {
              msg = { Text: data.errors[0], Type: "Error" };
              setAlertBoxmsg(msg);
            }
          }

          setOpenloader(false);
        },
        (error) => {
          setOpenloader(false);
          // let msg: Message = {
          //   Text: "Something went wrong please try again.",
          //   Type: "Error",
          // };
          // setAlertBoxmsg(msg);
          console.log("API Error: " + apiUrl + " " + error);
          navigate("/SessionExpired");
        }
      )
      .catch((err) => {
        if (err.message === "Failed to fetch") {
          navigate("/SessionExpired");
        } else {
          //API Error.
          let msgError: Message = {
            Text: err.message,
            Type: "Error",
          };
          setAlertBoxmsg(msgError);
        }
      })
      .finally(() => {
        setOpenloader(false);
      });
  };
  return (
    <div className="page-container">
      <div className="add-user-details">
        <Loader value={openLoader}></Loader>
          <Container component="main" maxWidth="md">
            <CssBaseline />
            <Box
              sx={{
                marginTop: 5,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Typography
                component="h1"
                variant="h5"
                style={{
                  display: "flex",
                  alignItems: "center",
                  flexWrap: "wrap",
                }}
              >
                <PersonAdd sx={{ fontSize: 30, marginRight: 1 }} />
                <b>{isUpdateForm ? "Update User" : "Add User"}</b>
              </Typography>

              {alertBoxmsg.Text !== "" && (
                <AlertBox value={alertBoxmsg}></AlertBox>
              )}

              <Box component="form" noValidate sx={{ mt: 3 }}>
                <Grid container spacing={4}>
                  <Grid item xs={12} sm={6}>
                    {" "}
                    <TextField
                      id="email"
                      label="Email"
                      type="email"
                      fullWidth
                      disabled={isUpdateForm}
                      value={userInfo.email}
                      onChange={(e) => handleInputChange(e)}
                      variant="outlined"
                      required
                      error={formValidation.email}
                      helperText={
                        formValidation.email
                          ? userInfo.email == ""
                            ? "Error : Field is required"
                            : "Error : Invalid email address."
                          : ""
                      }
                    />
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <TextField
                      id="phoneNumber"
                      label="Phone Number"
                      fullWidth
                      value={userInfo.phoneNumber}
                      onChange={(e) => handleInputChange(e)}
                      variant="outlined"
                      error={formValidation.phoneNumber}
                      helperText={
                        formValidation.phoneNumber
                          ? "Error : Maximum 25 characters are allowed in phone number."
                          : ""
                      }
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-helper-label">
                        Type*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="userType"
                        label="Type"
                        value={userInfo.userType}
                        required
                        error={formValidation.userType}
                        onChange={(e) => handleSelectChange(e, "userType")}
                      >
                       
                       <MenuItem  style={{display: isShowSuperAdmin ? 'block' : 'none'}} value="Super Admin">Super Admin</MenuItem>
                        <MenuItem value="Admin">Admin</MenuItem>
                        <MenuItem value="DSV Employee">DSV Employee</MenuItem>
                        <MenuItem value="External User">External User</MenuItem>
                        <MenuItem value="External DSV User">External DSV User</MenuItem>
                      </Select>
                      {formValidation.userType ? (
                        <FormHelperText style={{ color: "#d32f2f" }}>
                          Error : Field is required
                        </FormHelperText>
                      ) : (
                        ""
                      )}
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="firstName"
                      label="First Name"
                      fullWidth
                      variant="outlined"
                      value={userInfo.firstName}
                      onChange={(e) => handleInputChange(e)}
                      required
                      error={formValidation.firstName}
                      helperText={
                        formValidation.firstName
                          ? "Error : Field is required"
                          : ""
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {" "}
                    <TextField
                      id="lastName"
                      label="Last Name"
                      fullWidth
                      value={userInfo.lastName}
                      onChange={(e) => handleInputChange(e)}
                      variant="outlined"
                    />
                  </Grid>

                  
                  <Grid item xs={12} sm={6}>
                    {" "}
                    <FormControl fullWidth>
                      <InputLabel id="demo-simple-select-helper-label">
                        Role*
                      </InputLabel>
                      <Select
                        labelId="demo-simple-select-helper-label"
                        id="roleID"
                        label="Type"
                        value={userInfo.roleID}
                        required
                        error={formValidation.roleID}
                        onChange={(e) => handleSelectChange(e, "roleID")  } 
                      >
                        {roleList.map((role) => (
                          <MenuItem key={role.id} value={role.id}>
                            {role.name}
                          </MenuItem>
                        ))}
                      </Select>
                      {formValidation.roleID ? (
                        <FormHelperText style={{ color: "#d32f2f" }}>
                          Error : Field is required
                        </FormHelperText>
                      ) : (
                      ""
                      )}
                    </FormControl>
                  </Grid>
              
                   {/* <Grid item xs={12} sm={8} style={{display: isShownMDMBTN ? 'block' : 'none'}} >
                    {" "}
                  <Button
                  variant="outlined" 
                  size="medium"   onClick={() => ManageMDM()}  
                  startIcon={<SettingsIcon />}
                  >
                  Manage MDM 
                </Button>{" "} 
                  </Grid>  */}
                  <Grid item xs={12} style={{display: isShownMDMBTN ? 'block' : 'none'}}>
                    <Stack
                      spacing={5}
                      pt={0}
                      direction="row"
                      className="MuiTextField-root"
                    >
                      <Typography variant="h6" component="div">
                        <b> MDM Services</b>
                      </Typography>
                    </Stack>
                    <Stack>
                    <TextField
                    label="Search"
                    value={searchText}
                    onChange={handleSearchChange}
                    variant="outlined"
                    size="small"
                    fullWidth
                    />
                    </Stack>
                    <Stack direction="row">                  
                      <div
                        style={{
                          width: "100%",
                          height: "10%",
                          overflow: "auto",
                          backgroundColor: "#F2F2F2",
                          borderRadius: "2px",
                        }}
                      >
                        {
                          <List
                            sx={{
                              width: "100%",
                              height: "180px",
                            }}
                          >
                            {filteredOptions.map((mdmAccesses) => (
              <ListItem>
                <ListItemText
                  id= {mdmAccesses.description}
                  primary={mdmAccesses.description}
                />
                <Switch
                  edge="end"
                  onChange={handleRoleToggle(mdmAccesses)}
                  checked={mdmchecked.indexOf(getRoleID(mdmAccesses)) !== -1}
                  inputProps={{
                    "aria-labelledby": "switch-list-label-wifi",
                  }}
                />
              </ListItem>
            ))}
                          </List>
                        }
                      </div>
                    </Stack>
                  </Grid>
                  {/* <Grid item xs={12} sm={4} style={{display: isShownMDMBTN ? 'block' : 'none'}}>
                    {" "}                   
                  </Grid>               */}
                    <Grid item xs={12}>
                   <Stack spacing={1} padding={1} direction="row">                
                    <FormControlLabel
                      className="chekcBox"
                      control={
                        <Checkbox
                          checked={isChecked}
                          onChange={handleCheckboxChange}
                          name="isActive"
                          id="isActive"
                        />
                      }
                      label="Enabled"
                    />  
                               
                    <Button
                      variant="contained"
                      size="medium"
                      startIcon={<LabelImportantIcon />}
                      onClick={() => handleSubmit()}
                    >
                      Submit 
                    </Button> 
                    <Button
                      size="medium"
                      variant="outlined"
                      onClick={() => navigate("/UserList")}
                    >
                      Cancel
                    </Button>                
                  </Stack>  
                  </Grid>                  
                </Grid>
              </Box>
            </Box>
          </Container>
      </div>{" "}
      <div className="blank-div"></div>
    </div>
  );
}

export default CreateEditUser;